export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}

export function setSessionCookie(name, value) {
  document.cookie = `${name}=${value};`;
}

export function setCookie(name, value, days = null, path = '/') {
  const maxAge = days ? ` max-age=${days * 24 * 60 * 60};` : '';

  document.cookie = `${name}=${value}; path=${path};${maxAge} SameSite=Lax;`;
}
